import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

function ReceivedLikes() {
  const [receivedLikes, setReceivedLikes] = useState([]);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(true);

  const { token, logout } = useAuth();

  useEffect(() => {
    async function fetchReceivedLikes() {
      if (!token) {
        setError("You must be logged in to view received likes.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const response = await axios.get(
          "/api/likes/received",
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        console.log("Received likes:", response.data);

        setReceivedLikes(response.data);
      } catch (err) {
        console.error("Received likes error:", err);

        if (err.response && err.response.status === 401) {
          logout();
          setError("Session expired. Please login again.");
        } else if (err.response && err.response.data) {
          setError(err.response.data);
        } else {
          setError("Failed to load received likes.");
        }
      } finally {
        setLoading(false);
      }
    }

    fetchReceivedLikes();
  }, [token, logout]);

  async function handleLikeBack(userId) {
    try {
      setError("");
      setSuccessMessage("");

      const response = await axios.post(
        `/api/likes/${userId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log("Like back response:", response.data);

      setReceivedLikes((previousLikes) =>
        previousLikes.filter((user) => user.id !== userId)
      );

      if (response.data.status === "MATCH_CREATED") {
        setSuccessMessage("It's a match! You can now chat in Matches.");
      } else {
        setSuccessMessage("Like sent.");
      }
    } catch (err) {
      console.error("Like back error:", err);

      if (err.response && err.response.status === 401) {
        logout();
        setError("Session expired. Please login again.");
      } else if (err.response && err.response.data) {
        setError(err.response.data);
      } else {
        setError("Failed to like back.");
      }
    }
  }

  if (loading) {
    return (
      <div>
        <h1>Received Likes</h1>
        <p>Loading received likes...</p>
      </div>
    );
  }

  return (
    <div>
      <h1>Received Likes</h1>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {successMessage && (
        <p style={{ color: "green" }}>{successMessage}</p>
      )}

      {receivedLikes.length === 0 && !error && (
        <p>No pending received likes.</p>
      )}

      <div>
        {receivedLikes.map((user) => (
          <div
            key={user.id}
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "15px",
              maxWidth: "500px"
            }}
          >
            {user.photoUrl && (
              <img
                src={user.photoUrl}
                alt={user.username}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "10px"
                }}
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
            )}

            <h2>{user.username}</h2>

            <p>
              <strong>Age:</strong> {user.age}
            </p>

            <p>
              <strong>Gender:</strong> {user.gender}
            </p>

            {(user.country || user.city) && (
              <p>
                <strong>Location:</strong>{" "}
                {[user.city, user.country].filter(Boolean).join(", ")}
              </p>
            )}

            <p>
              <strong>Bio:</strong> {user.bio}
            </p>

            <button onClick={() => handleLikeBack(user.id)}>
              Like Back
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReceivedLikes;
